import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { MyContext } from '../MainContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faUserPlus, faComment, faPray, faBell } from '@fortawesome/free-solid-svg-icons';

const NOTIFICATION_POLL_INTERVAL_MS = 30000;
const TOAST_AUTO_DISMISS_MS = 6000;

const iconByType = {
  message_request: faEnvelope,
  new_message: faComment,
  new_follower: faUserPlus,
  new_prayer_request: faPray,
  group_prayer_request: faPray,
  default: faBell
};

const routeByType = {
  message_request: '/messages/requests',
  new_message: '/messages',
  new_follower: null,
  new_prayer_request: '/prayers',
  group_prayer_request: '/prayers',
  default: null
};

function NotificationToastItem({ item, onDismiss, onDismissAll, onNavigate }) {
  const icon = iconByType[item.type] || iconByType.default;
  const route = item.link || routeByType[item.type] || routeByType.default;

  useEffect(() => {
    const t = setTimeout(() => onDismiss(item.id), TOAST_AUTO_DISMISS_MS);
    return () => clearTimeout(t);
  }, [item.id, onDismiss]);

  const handleClick = () => {
    onDismissAll();
    if (route && onNavigate) {
      onNavigate(route);
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={(e) => e.key === 'Enter' && handleClick()}
      className="notification-toast-item"
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: '10px',
        padding: '12px 14px',
        background: '#fff',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        marginBottom: '8px',
        cursor: route ? 'pointer' : 'default',
        borderLeft: '4px solid #48887b',
        maxWidth: '320px',
        minWidth: '280px'
      }}
    >
      <div style={{ color: '#48887b', marginTop: '2px' }}>
        <FontAwesomeIcon icon={icon} />
      </div>
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 600, marginBottom: '4px', fontSize: '14px' }}>{item.title}</div>
        <div style={{ fontSize: '13px', color: '#555' }}>{item.body}</div>
      </div>
    </div>
  );
}

export default function NotificationToast() {
  const { user, notificationToasts, removeNotificationToast, clearAllNotificationToasts } = useContext(MyContext);
  const navigate = useNavigate();

  if (!user || !user.user_id || !notificationToasts || notificationToasts.length === 0) {
    return null;
  }

  return (
    <div
      className="notification-toast-container"
      style={{
        position: 'fixed',
        top: '16px',
        right: '16px',
        zIndex: 10000,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end'
      }}
    >
      {notificationToasts.map((item) => (
        <NotificationToastItem
          key={item.id}
          item={item}
          onDismiss={removeNotificationToast}
          onDismissAll={clearAllNotificationToasts}
          onNavigate={(path) => navigate(path)}
        />
      ))}
    </div>
  );
}

